export const isPoliciesExportEnabled = 'ih-3154-export-questionnaire';
export const isTenantSpecifiedStylesEnabled =
  'ih-3916-istenantspecificstylesenabled';
